interface AvatarProps {
  name: string;
  size?: "sm" | "md" | "lg";
  tone?: "primary" | "accent" | "secondary";
}

const sizeMap = {
  sm: "w-7 h-7 text-xs",
  md: "w-10 h-10 text-sm",
  lg: "w-20 h-20 text-2xl",
};

const toneMap = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function Avatar({ name, size = "md", tone = "primary" }: AvatarProps) {
  const initial = name ? name.slice(0, 1) : "?";
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-heading font-semibold shrink-0 ${sizeMap[size]} ${toneMap[tone]}`}
      aria-hidden="true"
    >
      {initial}
    </span>
  );
}